import React, { Component } from 'react'
import _ from 'lodash'
import { getTestimonials } from '../../api/butterCMS'
import ContentBlock from '../ContentBlock'
import ContentScroller from '../ContentScroller'
import { Testimonial } from '../index'

class TestimonialsScroller extends Component {

    constructor(props) {
        super(props)
        const { testimonials } = this.props

        this.state = {
            testimonials: testimonials || []
        }
    }

    componentDidMount() {
        const { testimonials  } = this.props
        if (!testimonials) {
            this.loadTestimonials()
        }
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(this.props.testimonials, prevProps.testimonials)) {
            const { testimonials } = this.props
            this.setState({
                testimonials
            })
        }
    }

    loadTestimonials() {
        getTestimonials().then(testimonials => {
            this.setState({ testimonials: testimonials.testimonial })
        })
    }

    render() {
        const { testimonials } = this.state

        if (testimonials.length && testimonials.length < 2) {
            return (
                <ContentBlock className="content-block content-block--narrow u-no-padding--x-only">
                    <Testimonial testimonial={testimonials[0]} />
                </ContentBlock>
            )
        }

        return (
            <ContentScroller>
                {testimonials.map((testimonial, k) => (
                    <Testimonial key={k} testimonial={testimonial} />
                ))}
            </ContentScroller>
        )
    }
}

export default TestimonialsScroller


// WEBPACK FOOTER //
// ./src/components/Testimonials/TestimonialsScroller.js